'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryAddController = function () {
  function CategoryAddController(ImagesDataProvider, $state, $timeout, API_URL) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CategoryAddController);
    this.category = {};
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.errorShow = 0;
  }

  (0, _createClass3.default)(CategoryAddController, [{
    key: 'onvertToSlug',
    value: function onvertToSlug(text) {
      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
    }
  }, {
    key: 'create',
    value: function create(form) {
      if (!form) {
        return false;
      }
      var vm = this;
      vm.category.slug = vm.onvertToSlug(vm.category.name);
      vm.ImagesDataProvider.saveCategory(vm.category).then(function (res) {
        if (res.exist == '1') {
          vm.existRecord = 1;
        } else {
          vm.$state.go('app.imageCategories');
        }
      });
    }
  }]);
  return CategoryAddController;
}();

// WEBPACK FOOTER //


exports.default = CategoryAddController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/images/components/category_add/controller.js
 **/